// extracted by mini-css-extract-plugin
module.exports = {"total":"CarryOverDetail_total__UhCGu"};